import React, { useRef, useEffect, useState } from 'react';
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax

import { useQuery } from '@tanstack/react-query';

import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';

import { getAllDevices } from 'api/bks';

import 'mapbox-gl/dist/mapbox-gl.css';

// props-types is a library for typechecking of props
import PropTypes from "prop-types";

import Card from "@mui/material/Card";
import Box from '@mui/material/Box';

import { center, bbox, bboxPolygon, difference, featureCollection } from "@turf/turf";
import geoViewport from "@mapbox/geo-viewport";
import { getUserAccessLevel } from 'helper/user';

import cameraIcon from 'nextus-assets/images/camera.png';
import moment from 'moment';
import { CardMembershipSharp, Circle } from '@mui/icons-material';

import { Threebox } from 'threebox-plugin';
// import tramObj from "nextus-assets/images/SubwayCar_Compiled.fbx";
import tramObj from "nextus-assets/models/lightRail_v7.fbx";

import './styles.css';

mapboxgl.accessToken = 'pk.eyJ1IjoiaGFycnltb250YW5vIiwiYSI6ImNqZWY0bDcyaTFkcGYzM28ydHFpaDJxaWcifQ.Wf7aNVePBRWZ9fMy_I81qw';

function getText(epoch) {
    if (epoch) {
        return "Captured: " + moment.duration((moment().unix() * 1000) - (epoch * 1000)).humanize({ ss: 3 }) + " ago - " + moment(epoch * 1000).format("HH:mm:ss");
    }
    else {
        return "Unavailable";
    }
}

function HeatMap({ lightPreset, map_data, static_map_data, settings, padding, user_role = "viewer", children, loading, isLive, epoch, selectedDevices, hoveredDevices, setHoveredDevices, navigateToDevice, event_id }) {
    // debugger;

    const mapContainer = useRef(null);
    const entireDiv = useRef(null);
    const map = useRef(null);

    var latest_camera_data = useRef({});

    const [opacity, setOpacity] = useState(0);

    const popup = new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: false
    });

    useEffect(() => {
        // console.log('fit bounds')
        if (map.current) {
            // debugger;
            // console.log(map_data.camera_polygons)

            var bounds = bbox({
                "type": "FeatureCollection",
                "features": map_data.camera_polygons.map(r => r.geojson)
            });

            try {
                var bboxpolygon = bboxPolygon(bounds);
                map.current.fitBounds(bboxpolygon.bbox, {
                    linear: true,
                    padding: {
                        top: 100,
                        bottom: 200,
                        left: 100,
                        right: 100,

                    },
                    pitch: 60,
                    bearing: 15,
                    duration: 200
                });
            }
            catch (e) {
                console.error(e)
            }

            // if (map_data.camera_polygons.length > 1) {
            //     // debugger;
            //     if (event_id == '68a29d8e6d5147509f4d7bbe') {
            //         map.current.jumpTo({
            //                 "pitch": 55.98467892179223,
            //                 "center": [
            //                     151.22159856601786,
            //                     -33.892347676207706
            //                 ],
            //                 "zoom": 16.31424366971548
            //             })
            //     }
            //     else if (event_id == '1') {

            //     }
            // }
            // else {

            // }


        }
    }, [selectedDevices])

    useEffect(() => {
        updateMap(map.current, map_data)
    }, [map_data, hoveredDevices]);


    useEffect(() => {
        // debugger;
        if (map.current) {
            map.current.setConfigProperty('basemap', 'lightPreset', lightPreset);
        }

    }, [lightPreset]);



    useEffect(() => {
        if (map.current) {
            return;
        }


        var map_settings = settings;
        map_settings.container = mapContainer.current;
        // debugger;
        map_settings.config = {
            basemap: {
                lightPreset: lightPreset
            }
        };
        // map_settings.center = center({
        //     "type": "FeatureCollection",
        //     "features": features
        // }).geometry.coordinates;

        // debugger;
        map.current = new mapboxgl.Map(map_settings);

        const size = 100;

        const pulsingDot = {
            width: size,
            height: size,
            data: new Uint8Array(size * size * 4),

            onAdd: function () {
                const canvas = document.createElement('canvas');
                canvas.width = this.width;
                canvas.height = this.height;
                this.context = canvas.getContext('2d');
            },

            render: function () {
                const duration = 1000;
                const t = (performance.now() % duration) / duration;

                const radius = (size / 2) * 0.3;
                const outerRadius = (size / 2) * 0.7 * t + radius;
                const context = this.context;

                let img = new Image();
                img.src = cameraIcon;

                context.clearRect(0, 0, this.width, this.height);
                context.beginPath();
                context.arc(
                    this.width / 2,
                    this.height / 2,
                    outerRadius,
                    0,
                    Math.PI * 2
                );


                context.fillStyle = `rgba(255, 200, 200, ${1 - t})`;
                context.fill();
                //   console.log(img)
                context.drawImage(img, (this.width / 2) - 15, (this.height / 2) - 15);
                context.beginPath();
                //   context.arc(this.width / 2, this.height / 2, radius, 0, Math.PI * 2);
                context.fillStyle = 'rgba(255, 255, 255, 0.3)';
                context.strokeStyle = 'white';
                context.lineWidth = 2 + 4 * (1 - t);
                context.fill();
                context.stroke();

                this.data = context.getImageData(0, 0, this.width, this.height).data;

                map.current.triggerRepaint();

                return true;
            }
        };

        map.current.on('load', () => {

            var existing_camera_image = map.current.hasImage(`cameraIcon`);
            map.current.loadImage(
                cameraIcon, (error, image) => {
                    if (error) throw error;
                    if (!existing_camera_image) {
                        map.current.addImage(`cameraIcon`, image);
                    }
                }
            );

            // var existing_camera_image = map.current.hasImage(`carIcon`);
            // map.current.loadImage(
            //     carIcon, (error, image) => {
            //         if (error) throw error;
            //         if (!existing_camera_image) {
            //             map.current.addImage(`carIcon`, image);
            //         }
            //     }
            // );

            map.current.addControl(new mapboxgl.FullscreenControl({ container: entireDiv.current }));
            map.current.addControl(new mapboxgl.NavigationControl(new mapboxgl.NavigationControl({
                visualizePitch: true,
                showZoom: true,
                showCompass: true
            })));


            map.current.addImage('pulsing-dot', pulsingDot, { pixelRatio: 1 });

            map.current.addSource('routes', {
                type: 'geojson',
                data: {
                    type: 'FeatureCollection',
                    features: []
                }
            });

            map.current.addSource('camera-icons', {
                type: 'geojson',
                data: {
                    type: 'FeatureCollection',
                    features: []
                }
            });

            map.current.addSource('vehicles', {
                type: 'geojson',
                data: {
                    type: 'FeatureCollection',
                    features: []
                }
            });

            map.current.addSource('trams', {
                type: 'geojson',
                data: {
                    type: 'FeatureCollection',
                    features: []
                }
            });

            map.current.addSource('buses', {
                type: 'geojson',
                data: {
                    type: 'FeatureCollection',
                    features: []
                }
            });

            map.current.addSource('heatmap', {
                type: 'geojson',
                data: {
                    "type": "FeatureCollection",
                    "features": []
                }
            });

            map.current.addSource('camera-polygons', {
                type: 'geojson',
                data: {
                    "type": "FeatureCollection",
                    "features": []
                }
            });

            map.current.addLayer({
                'id': 'camera-polygons',
                'type': 'fill',
                'source': 'camera-polygons', // reference the data source
                'layout': {},
                'paint': {
                    'fill-color': '#000000', // blue color fill
                    'fill-opacity': [
                        'interpolate',
                        ['linear'],
                        ['zoom'], //input 0
                        0, 0,
                        15, 0.1,
                        17, 0.3
                    ],
                }
            });

            map.current.on('moveend', function () {
                const currentPitch = map.current.getPitch();
                const currentCenter = map.current.getCenter(); // Returns an LngLat object
                const currentZoom = map.current.getZoom();


                console.log({
                    pitch: currentPitch,
                    center: [currentCenter.lng, currentCenter.lat],
                    zoom: currentZoom
                })
            });









            // map.current.addLayer({
            //     id: `heatmap-heat`,
            //     type: 'heatmap',
            //     source: `heatmap`,
            //     maxzoom: 24,
            //     paint: {
            //         // Increase the heatmap weight based on frequency and property magnitude
            //         'heatmap-weight': [
            //             'interpolate',
            //             ['linear'],
            //             ['get', 'count'],
            //             0, 0, // if zoom is less than [1], use [2] as heatmap-weight
            //             14, 1 // if zoom is greater than [3], use [4]. Interpolate linearly between
            //         ],
            //         // Increase the heatmap color weight weight by zoom level
            //         // heatmap-intensity is a multiplier on top of heatmap-weight
            //         'heatmap-intensity': [
            //             'interpolate',
            //             ['linear'],
            //             ['zoom'],
            //             1, 3,
            //             12, 1
            //         ],
            //         // Color ramp for heatmap.  Domain is 0 (low) to 1 (high).
            //         // Begin color ramp at 0-stop with a 0-transparancy color
            //         // to create a blur-like effect.
            // 'heatmap-color': [
            //     'interpolate',
            //     ['linear'],
            //     ['heatmap-density'],
            //     0,
            //     'rgba(33,102,172,0)',
            //     0.15,
            //     'rgb(38, 124, 204)',
            //     0.3,
            //     'rgb(131, 180, 226)',
            //     // 0.6,
            //     // 'rgb(253,219,199)',
            //     0.6,
            //     'rgb(239,128,98)',
            //     0.9,
            //     'rgb(255, 24, 24)'
            // ],
            //         // Adjust the heatmap radius by zoom level
            //         'heatmap-radius': [
            //             'interpolate',
            //             ['linear'],
            //             ['zoom'],
            //             0, 8,
            //             16, 60
            //         ],
            //         // Transition from heatmap to circle layer by zoom level
            //         'heatmap-opacity': [
            //             'interpolate',
            //             ['linear'],
            //             ['zoom'],
            //             17, 1,
            //             20, 0
            //         ]
            //     }
            // });

            map.current.addLayer({
                'id': 'routes',
                'type': 'line',
                'source': 'routes',
                'layout': {
                    'line-join': 'round',
                    'line-cap': 'round'
                },
                'paint': {
                    'line-color': '#888',
                    'line-width': 8
                }
            });



            map.current.addLayer({
                id: 'camera-icons',
                type: 'symbol',
                source: 'camera-icons',
                layout: {
                    "icon-image": [
                        "case",
                        ["boolean", ["get", "use_blink"], false], // If 'selected' is true
                        "pulsing-dot", // Color for true
                        "cameraIcon"  // Color for false or other cases
                    ],
                    'icon-size': 0.7,
                    'icon-rotate': ['get', 'rotation'],
                    "icon-allow-overlap": true,
                    "icon-rotation-alignment": "map",
                    'opacity': [
                        'interpolate',
                        ['linear'],
                        ['zoom'],
                        16, 1,
                        18, 0
                    ]
                }
            });

            map.current.addLayer({
                'id': 'vehicles',
                'type': 'fill-extrusion',
                'source': 'vehicles', // reference the data source
                'layout': {},
                'paint': {
                    'fill-color': ['get', 'colour'],
                    'fill-opacity': 0.8,
                    'fill-extrusion-color': ['get', 'colour'],
                    'fill-extrusion-height': 2,
                    'fill-extrusion-base': 0,
                    'fill-extrusion-opacity': 0.8,
                    'fill-extrusion-emissive-strength': 1,
                    'fill-extrusion-flood-light-intensity': 1,
                    'fill-extrusion-flood-light-ground-radius': 40,
                    'fill-extrusion-flood-light-wall-radius': 40
                }
            });

            map.current.addLayer({
                id: `trams`,
                type: 'circle',
                source: `trams`,
                minzoom: 10,
                paint: {
                    // Size circle radius by earthquake magnitude and zoom level
                    'circle-color': '#DD1E25',
                    'circle-radius': 5,
                    'circle-stroke-color': 'white',
                    'circle-stroke-width': 2,
                    'circle-emissive-strength': 2
                }
            });

            // map.current.addLayer({
            //     id: `trams`,
            //     type: 'symbol',
            //     source: `trams`,
            //     minzoom: 10,
            //     layout: {
            //         'icon-image': 'carIcon',
            //         'icon-size': 0.08,
            //         'icon-rotate': ['get', 'rotation'],
            //         "icon-allow-overlap": true,
            //         "icon-rotation-alignment": "map",
            //         'opacity': [
            //             'interpolate',
            //             ['linear'],
            //             ['zoom'],
            //             16, 1,
            //             18, 0
            //         ]
            //     }
            // });

            map.current.addLayer({
                id: `buses`,
                type: 'circle',
                source: `buses`,
                minzoom: 10,
                paint: {
                    // Size circle radius by earthquake magnitude and zoom level
                    'circle-color': '#009ED7',
                    'circle-radius': 5,
                    'circle-stroke-color': 'white',
                    'circle-stroke-width': 2,
                    'circle-emissive-strength': 2
                }
            });

            map.current.addLayer({
                id: `heatmap-point`,
                type: 'heatmap',
                source: `heatmap`,
                filter: ['>', ['get', 'strength'], 0.05],
                "paint": {
                    'heatmap-weight': [
                        'interpolate',
                        ['linear'],
                        ['get', 'strength'],
                        0,
                        0,
                        1,
                        1
                    ],
                    'heatmap-radius': [
                        'interpolate',
                        ['exponential', 2],
                        ['zoom'],
                        0, 0,
                        20, [
                            '/',
                            ['/', ['get', 'radius'], (0.075)],
                            ['cos', ['*', ['get', 'lat'], ['/', Math.PI, 180]]],
                        ],
                    ],
                    'heatmap-color': [
                        'interpolate',
                        ['linear'],
                        ['heatmap-density'],
                        0,
                        'rgba(33,102,172,0)',
                        0.15,
                        'rgb(38, 124, 204)',
                        0.3,
                        'rgb(131, 180, 226)',
                        // 0.6,
                        // 'rgb(253,219,199)',
                        0.6,
                        'rgb(239,128,98)',
                        0.9,
                        'rgb(255, 24, 24)'
                    ],
                    'heatmap-intensity': [
                        'interpolate',
                        ['linear'],
                        ['zoom'],
                        5,
                        1.5,
                        18,
                        1
                    ],

                    // 'heatmap-color': [
                    //     'interpolate',
                    //     ['linear'],
                    //     ['heatmap-density'],
                    //     0,
                    //     'rgba(33,102,172,0)',
                    //     0.15,
                    //     'rgb(38, 124, 204)',
                    //     0.3,
                    //     'rgb(131, 180, 226)',
                    //     // 0.6,
                    //     // 'rgb(253,219,199)',
                    //     0.6,
                    //     'rgb(239,128,98)',
                    //     0.9,
                    //     'rgb(255, 24, 24)'
                    // ],
                },

                // 'heatmap-color': [
                //     'interpolate',
                //     ['linear'],
                //     ['heatmap-density'],
                //     0,
                //     'rgba(33,102,172,0)',
                //     0.15,
                //     'rgb(38, 124, 204)',
                //     0.3,
                //     'rgb(131, 180, 226)',
                //     // 0.6,
                //     // 'rgb(253,219,199)',
                //     0.6,
                //     'rgb(239,128,98)',
                //     0.9,
                //     'rgb(255, 24, 24)'
                // ],
            })

            // minzoom: 17,
            // filter: ['>', ['get', 'margin'], 0.15],
            // paint: {
            //     // Size circle radius by earthquake magnitude and zoom level
            //     'circle-radius': 5,
            //     // [
            //     //     'interpolate',
            //     //     ['linear'],
            //     //     ['zoom'],
            //     //     16, [
            //     //         'interpolate',
            //     //         ['linear'],
            //     //         ['get', 'count'],
            //     //         1, 1,
            //     //         6, 4
            //     //     ],
            //     //     19, [
            //     //         'interpolate',
            //     //         ['linear'],
            //     //         ['get', 'count'],
            //     //         1, 5,
            //     //         6, 50
            //     //     ]
            //     // ],
            //     // Color circle by earthquake magnitude

            //     'circle-stroke-color': 'white',
            //     'circle-stroke-width': 2,
            //     // Transition from heatmap to circle layer by zoom level
            //     'circle-opacity': [
            //         'interpolate',
            //         ['linear'],
            //         ['zoom'],
            //         17, 0,
            //         19, 1
            //     ]
            // }


            map.current.addLayer({
                id: 'custom-threebox-model',
                type: 'custom',
                renderingMode: '3d',
                onAdd: function () {
                    window.tb = new Threebox(
                        map.current,
                        map.current.getCanvas().getContext('webgl'),
                        {
                            defaultLights: true,
                        }
                    );

                },

                render: function () {
                    window.tb.update();
                }
            });


            map.current.on('click', 'camera-icons', (e) => {
                // Change the cursor style as a UI indicator.
                navigateToDevice(e.features[0].properties.uuid)
            });


            map.current.on('mouseenter', 'camera-icons', (e) => {
                // Change the cursor style as a UI indicator.
                // debugger;
                // debugger

                // Copy coordinates array.
                const coordinates = e.features[0].geometry.coordinates.slice();
                setHoveredDevices([e.features[0].properties.uuid]);
                // debugger;
                const description = e.features[0].properties.name + '<br>' + getText(e.features[0].properties.timestamp);


                // Ensure that if the map is zoomed out such that multiple
                // copies of the feature are visible, the popup appears
                // over the copy being pointed to.
                if (['mercator', 'equirectangular'].includes(map.current.getProjection().name)) {
                    while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                        coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
                    }
                }

                // Populate the popup and set its coordinates
                // based on the feature found.
                popup.setLngLat(coordinates).setHTML(description).addTo(map.current);
                map.current.getCanvas().style.cursor = 'pointer';
            });

            map.current.on('mouseleave', 'camera-icons', () => {
                map.current.getCanvas().style.cursor = '';
                popup.remove();
                setHoveredDevices([]);
            });

            // console.log(map_data)

            updateMap(map.current, map_data);

            // map.current.fitBounds(bboxpolygon.bbox, { linear: true, padding: padding, duration: 200 });
            setOpacity(1);

            var bounds = bbox({
                "type": "FeatureCollection",
                "features": map_data.camera_polygons.map(r => r.geojson)
            });

            try {
                var bboxpolygon = bboxPolygon(bounds);
                map.current.fitBounds(bboxpolygon.bbox, {
                    linear: true,
                    padding: {
                        top: 100,
                        bottom: 200,
                        left: 100,
                        right: 100,

                    },
                    pitch: 60,
                    bearing: 15,
                    duration: 200
                });
            }
            catch (e) {
                console.error(e)
            }
        });
    }, []);

    function updateMap(map, data) {

        // console.log(data)

        if (!map) {
            return;
        }

        // debugger;
        // console.log(map);
        var camera_icons_source = map.getSource("camera-icons");
        var camera_polygons_source = map.getSource("camera-polygons");
        var trams_source = map.getSource("trams");
        var vehicles_source = map.getSource("vehicles");
        var buses_source = map.getSource("buses");
        var routes_source = map.getSource("routes");


        var heatmap_source = map.getSource("heatmap");

        if (!heatmap_source || !camera_icons_source || !camera_polygons_source || !trams_source || !buses_source || !routes_source) {
            return;
        }

        if (hoveredDevices.length) {
            // debugger;
            data = {
                ...data,
                heatmap: data.heatmap.filter(r => hoveredDevices.indexOf(r.uuid) >= 0),
                camera_points: data.camera_points.filter(r => hoveredDevices.indexOf(r.uuid) >= 0),
                camera_polygons: data.camera_polygons.filter(r => hoveredDevices.indexOf(r.uuid) >= 0)
            }
        }

        var camera_icons = [];

        var now = moment().unix();

        for (var camera of data.camera_points) {

            let use_blink = false;

            let row = {
                type: "Feature",
                properties: {
                    id: `camera`,
                    uuid: camera.uuid,
                    timestamp: camera.timestamp,
                    rotation: camera.bearing,
                    name: camera.name
                },
                geometry: {
                    type: 'Point',
                    coordinates: [camera.position.longitude, camera.position.latitude]
                }
            }

            if (!latest_camera_data.current[camera.uuid]) {
                latest_camera_data.current[camera.uuid] = {
                    timestamp: camera.timestamp
                }
            }
            else if (latest_camera_data.current[camera.uuid].timestamp != camera.timestamp && camera.timestamp) {
                latest_camera_data.current[camera.uuid].timestamp = camera.timestamp;
                latest_camera_data.current[camera.uuid].played_at = moment().unix();
                // debugger;
                use_blink = true;
            }
            else if (latest_camera_data.current[camera.uuid].played_at + 2 > moment().unix()) {
                use_blink = true;
            }

            row.properties.use_blink = use_blink;
            camera_icons.push(row);


        }

        // console.log(latest_camera_data)

        var points = data.heatmap.map(function (object, index) {
            // debugger;
            // console.log(object.weight * (1/(object.radius * 1000)))
            return {
                type: "Feature",
                properties: {
                    id: `point-${index}`,
                    // uuid: devices[device],
                    timestamp: object.timestamp,
                    uuid: object.uuid,
                    area: object.area,
                    weight: object.weight,
                    strength: object.strength,
                    radius: object.radius,
                    lat: object.polygon.geometry.coordinates[1]
                    // count: devices[device].current_data.count
                },
                geometry: object.polygon.geometry
            };
        });

        // debugger;

        // console.log(data.gtfs.trams)
        var vehicles = [];
        for (var tram of data.gtfs.trams.vehicle_positions) {
            if (tram.snapped) {
                vehicles.push(...tram.snapped.map(function (row) {
                    row.properties.colour = '#E4022D';

                    return row;
                }));
            }
        }

        vehicles.push(...data.gtfs.buses.vehicle_positions.map(function (row) {
            row.box.properties.colour = '#009ED7';

            return row.box;
        }));

        var trams = data.gtfs.trams.vehicle_positions.map(function (object, index) {
            return {
                type: "Feature",
                properties: {
                    // id: `point-${index}`,
                    // uuid: devices[device],
                    timestamp: object.timestamp,
                    // count: devices[device].current_data.count
                },
                geometry: {
                    type: 'Point',
                    coordinates: [object.position.longitude, object.position.latitude]
                }
            };
        });


        var buses = data.gtfs.buses.vehicle_positions.map(function (object, index) {
            return {
                type: "Feature",
                properties: {
                    // id: `point-${index}`,
                    // uuid: devices[device],
                    timestamp: object.timestamp,
                    // count: devices[device].current_data.count
                },
                geometry: {
                    type: 'Point',
                    coordinates: [object.position.longitude, object.position.latitude]
                }
            };
        });



        var bounds = [180, -90, -180, 90]; // whole planet
        var bboxPoly = bboxPolygon(bounds);

        var masks = data.camera_polygons.length ? difference(featureCollection([bboxPoly, ...data.camera_polygons.map(r => r.geojson)])) : bboxPoly;

        const scale = 0.05;

        // map.repaint = true;

        let promises = [];
        // console.log('here')
        // console.log(data.points)
        // window.tb.clear().then(function () {
        //     promises = data.trams.map(function (object, index) {
        //         // console.log(object.bearing)
        //         var options = {
        //             obj: tramObj,
        //             type: 'fbx',
        //             scale: { x: scale, y: scale, z: scale },
        //             units: 'meters',
        //             rotation: { x: 90, y: 0, z: 0 },
        //             anchor: 'center',
        //             id: index
        //         };
        //         // console.log(index);

        //         return new Promise((resolve) => {
        //             window.tb.loadObj(options, function (model) {
        //                 // console.log('options: ', options);
        //                 // console.log(object.bearing);
        //                 model.setRotation({ x: 0, y: 0, z: Number(object.bearing * -1) });
        //                 let obj = model.setCoords([object.longitude, object.latitude]);
        //                 window.tb.add(obj);

        //                 // console.log(object);

        //                 resolve(true);

        //             })
        //         })
        //     });

        //     // console.log(promises)
        //     Promise.all(promises).then((values) => {
        //         console.log("All promises finished:");
        //         tb.world.children.forEach((o) => {
        //             // console.log(o)
        //         });
        //     });
        // })

        // console.log(trams)
        // debugger;
        routes_source.setData(static_map_data)

        // debugger;

        // console.log(vehicles)

        vehicles_source.setData({
            type: 'FeatureCollection',
            features: vehicles
        })

        trams_source.setData({
            type: 'FeatureCollection',
            features: trams
        })

        buses_source.setData({
            type: 'FeatureCollection',
            features: buses
        })

        camera_polygons_source.setData({
            type: 'FeatureCollection',
            features: [masks]
        })

        camera_icons_source.setData({
            type: 'FeatureCollection',
            features: camera_icons
        });

        heatmap_source.setData({
            type: 'FeatureCollection',
            features: points
        });

        // console.log(heatmap_source.getData());
        // send to mapbox

    }


    useEffect(() => {
        setTimeout(function () {
            window.dispatchEvent(new Event("resize"));
        }, 700)

    }, [isLive]);

    useEffect(() => () => {
        if (map.current) {
            map.current.remove();
        }
        popup.remove();

    }, []);

    return (
        <Box sx={{ height: "100%", opacity }} ref={entireDiv}>
            <Box component="div" ref={mapContainer} sx={{ height: "100%", width: '100%', position: 'absolute' }} />
            <Box component="div" sx={{ height: '100%;', position: 'absolute', pointerEvents: loading ? 'all' : 'none', backgroundColor: 'none', width: '100%' }}>

                {isLive ? (
                    <SoftTypography sx={{ position: 'absolute', top: '10px', left: '20px', fontSize: 40, color: 'red' }}>
                        <span style={{ fontSize: "30px", marginRight: "10px" }}>
                            <Circle sx={{ color: "red" }} className="blink_me" />
                        </span>
                        LIVE
                    </SoftTypography>
                ) : (
                    <Card sx={{ opacity: 0.8, margin: '8px', paddingLeft: '8px', paddingRight: '8px', width: 'fit-content' }}>
                        <SoftBox p={1} display="flex" flexDirection="row" justifyContent="center">
                            <SoftTypography sx={{ fontSize: 30, color: 'white' }}>
                                {moment(epoch * 1000).format('LLL')}
                            </SoftTypography>
                        </SoftBox>
                    </Card>
                )}
                <Card sx={{ pointerEvents: "all", position: 'absolute', bottom: '5%', width: '90%', left: '5%' }}>
                    {children}
                </Card>
            </Box>
        </Box>

    );
}

HeatMap.propTypes = {
    current_map_points: PropTypes.array,
    map_data: PropTypes.object,
    static_map_data: PropTypes.object,
    map_points: PropTypes.object,
    settings: PropTypes.object,
    padding: PropTypes.number,
    user_role: PropTypes.string,
    children: PropTypes.element,
    loading: PropTypes.bool,
    isLive: PropTypes.bool,
    epoch: PropTypes.number,
    lightPreset: PropTypes.string,
    selectedDevices: PropTypes.string,
    hoveredDevices: PropTypes.string,
    navigateToDevice: PropTypes.func
};

export default HeatMap;